import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import type { App } from 'vue'
import { getMobileRouteType } from '@/utils/router-util.ts'

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/:id',
    name: 'Redirect',
    alias: '/',
    meta: {
      hidden: true,
      title: '直播',
      noTagsView: true
    }
  },
  {
    path: '/mobile/:id',
    name: 'Mobile',
    alias: '/mobile',
    component: () =>
      getMobileRouteType() === 'newMobile'
        ? import('@/views/new-mobile/new-mobile.vue')
        : import('@/views/mobile/mobile.vue'),
    meta: {
      hidden: true,
      title: '直播',
      noTagsView: true
    }
  },
  {
    path: '/mobilelogin/:id',
    name: 'MobileLogin',
    alias: '/mobilelogin',
    component: () => import('@/views/mobile/components/login/login.vue'),
    meta: {
      hidden: true,
      title: '登录',
      noTagsView: true
    }
  },

  {
    path: '/live/:id',
    alias: '/live',
    name: 'Live',
    component: () => import('@/views/live/live.vue'),
    meta: {
      hidden: true,
      title: '直播',
      noTagsView: true
    }
  },
  {
    path: '/CodeView/:id',
    alias: '/CodeView',
    name: 'CodeView',
    component: () => import('@/views/CodeView/codeView.vue'),
    meta: {
      hidden: true,
      title: '登录授权',
      noTagsView: true
    }
  },
  {
    path: '/nopremission/:id',
    alias: '/nopremission',
    name: 'NoFind',
    component: () => import('@/views/Error/404.vue'),
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/share/:id/:type',
    alias: '/share',
    name: 'share',
    component: () => import('@/views/share/share.vue'),
    meta: {
      hidden: true,
      title: 'share',
      noTagsView: true
    }
  },
  {
    path: '/personal/:id',
    alias: '/personal',
    name: 'personal',
    component: () => import('@/views/personal/personal.vue'),
    meta: {
      hidden: true,
      title: '个人中心',
      noTagsView: true
    }
  },
  {
    path: '/commodity/:id',
    alias: '/commodity',
    name: 'commodity',
    component: () => import('@/views/shareCommodity/shareCommodity.vue'),
    meta: {
      hidden: true,
      title: '商品',
      noTagsView: true
    }
  },
  {
    path: '/payCallbackPage/:id',
    alias: '/payCallbackPage',
    name: 'payCallbackPage',
    component: () => import('@/views/payCallbackPage/payCallbackPage.vue'),
    meta: {
      hidden: true,
      title: '支付完成',
      noTagsView: true
    }
  },
  {
    path: '/coupon/:id',
    alias: '/coupon',
    name: 'coupon',
    component: () => import('@/views/coupon/coupon.vue'),
    meta: {
      hidden: true,
      title: '优惠券',
      noTagsView: true
    }
  },
  {
    path: '/column/:id',
    alias: '/column',
    name: 'column',
    component: () => import('@/views/column/column.vue'),
    meta: {
      hidden: true,
      title: '栏目',
      noTagsView: true
    }
  },
  {
    path: '/pay',
    alias: '/pay',
    name: 'Pay',
    component: () => import('@/views/pay/index.vue'),
    meta: {
      hidden: true,
      title: '支付',
      noTagsView: true
    }
  },
  {
    path: '/wx-oauth/:id',
    alias: '/wx-oauth',
    name: 'wxOauth',
    component: () => import('@/views/wx-oauth/index.vue'),
    meta: {
      hidden: true,
      title: '登陆',
      noTagsView: true
    }
  }
]

// export const asyncRouterMap: AppRouteRecordRaw[] = [];

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

// export const resetRouter = (): void => {
//   const resetWhiteNameList = [
//     "Redirect",
//     "Login",
//     "NoFind",
//     "Root",
//     "share",
//     "test",
//   ];
//   router.getRoutes().forEach((route) => {
//     const { name } = route;
//     if (name && !resetWhiteNameList.includes(name as string)) {
//       router.hasRoute(name) && router.removeRoute(name);
//     }
//   });
// };

// router.beforeEach((to, from, next) => {
//   const routeName = to.name as string
//   if (['NewMobile', 'Mobile', 'commodity'].includes(routeName) && from.path !== to.path) {
//     openGlobalLoading(true)
//   } else {
//     closeGlobalLoading()
//   }
//   next();
// });

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
